import styled from 'styled-components';
import { MOBILE, LARGE, TABLET } from '@minerva-analytics/pantheon';
import { SALMON }  from '../../theme';

const SubscribeContainer = styled.div`
  padding-top: 1rem;
  display: flex;
  flex-direction: column;

  @media (max-width: ${LARGE}) {
    align-items: flex-start;
    margin-bottom: 2.5rem;
  }

  @media (max-width: ${MOBILE}) {
    padding: 0;
  }
`;

const SubscribeFormTheme = {
  Input: `
    border-radius: 6px;
    margin-right: 1rem;
    font-size: 18px; 
    @media (max-width: ${LARGE}) {
      width: 400px;
    }
    @media (max-width: ${TABLET}) {
      width: 300px;
    }
    @media (max-width: ${MOBILE}) {
      border-radius: 6px 0 0 6px;
      width: 100%;
      margin-right: 0;
    }
  `,
  Button:`
    background-color: ${SALMON};
    color: white;
    font-family: 'Source Sans Pro', sans-serif;
    border-radius: 6px;
    min-height: 37px;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 1px;

    :hover {
      background-color: #ed7b6d;
      transition: 0.5s;
    }

    @media (max-width: ${MOBILE}) {
      border-radius: 0 6px 6px 0;
      max-width: 4rem;
      min-width: 6.25rem;
    }
  `,
};
export { SubscribeContainer, SubscribeFormTheme };
